// extracted by mini-css-extract-plugin
var _1 = "xSs_IlXp8PhmSM1yalaI";
export { _1 as "notes" }
